// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowUpDown as RawArrowUpDown } from "lucide-react";
export const ArrowUpDown = /* @__PURE__ */ createIcon(RawArrowUpDown, "ArrowUpDown", 2);
